import './Error.scss';

import { Link } from 'react-router-dom';

import logo from '../Navbar/Logo_skinny.png';

const Error = () => {
  return(
    <div className='error'>
    
      <p className='error_message'>Error 404 </p>
      <p className='error_message'>Page non trouvée</p>

      <div className='back'>

      <p className='back_message'> - Cliquez sur le logo pour revenir à l'Accueil - </p>
      <Link to='/' className='back_link'> <img src={logo} alt='logo skinny' /></Link>
      
      </div>
    </div>
  )
}

export default Error;